import type { LegacyProduct } from '@app/types/product';
import { useXpressShipping } from '@drc/pages/Product/shared/components/XpressShipping/hooks';
import { Footer } from '../components/ProductTile/components/Footer';

const getXpressShipFooter = (product: Partial<LegacyProduct>) => {
  const hasXpressAsks = product?.market?.state?.numberOfCustodialAsks;
  const showXpressShippingFooter = useXpressShipping(hasXpressAsks);

  return showXpressShippingFooter && hasXpressAsks && Footer.XpressShipping;
};

export default getXpressShipFooter;
